import React from "react";

import styled from "styled-components/macro";

import { cellContainerStyles } from "./cellContainerStyles";

// const DateTimeCell = memo(dateTimeCell);
// export default DateTimeCell;

// Currently read-only - updating a DateTime will likely entail including a DatePicker when canEdit
export default function DateTimeCell({
  // columnID,
  // entityID,
  value = "",
  // saveCellValue,
  // canEdit,
}) {
  const lines = value.split(",");

  return (
    <Container>
      <div>{lines[0]}</div>
      <Line2>{lines[1]}</Line2>
    </Container>
  );
}

const Container = styled.div`
  ${cellContainerStyles};
  padding: 1px 5px 5px;
  white-space: nowrap;
`;

const Line2 = styled.div`
  margin-top: -1px;
  font-size: 11px;
  opacity: 0.8;
`;
